import React from 'react';
import {
    AvailableTimeSlots,
    BookerContainer,
    CalendarDays,
    DateCellSkeleton,
    DateGrid,
    DatePickerContainer,
    DatePickerHeader,
    MainSectionContainer,
    MetaSection,
    RowSkeleton,
    TimeslotsContainer,
} from './BookerMarkupComponents';

const BookerSkeleton: React.FC = () => {
    return (
        <div className='calcom-atoms atoms-wrapper booker-skeleton' dir='ltr'>
            <BookerContainer>
                <MetaSection>
                    <RowSkeleton />
                    <RowSkeleton />
                    <RowSkeleton />
                </MetaSection>
                <MainSectionContainer>
                    <DatePickerContainer>
                        <DatePickerHeader
                            month=' '
                            year=' '
                            actions={<RowSkeleton />}
                        />
                        <CalendarDays />
                        <DateGrid>
                            {[...Array(35)].map((_, i) => (
                                <DateCellSkeleton key={i} />
                            ))}
                        </DateGrid>
                    </DatePickerContainer>
                </MainSectionContainer>
                <TimeslotsContainer>
                    <AvailableTimeSlots
                        dayInWeek=' '
                        day=' '
                        slots={
                            <>
                                <RowSkeleton />
                                <RowSkeleton />
                            </>
                        }
                    />
                </TimeslotsContainer>
            </BookerContainer>
        </div>
    );
};

export default BookerSkeleton;
